export default "__VITE_ASSET__u5weCX4Q__"